module.exports = __webpack_public_path__ + "media/images/writer/monitor/sp-balloon@2x-4f6bf4ff1c43620228ac392fdb8fe2d0.png";